import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcStarsWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.689 8.0167L16.2047 13.5511C16.3262 13.8184 16.5404 14.0326 16.8077 14.1541L22.3421 16.6698C22.6268 16.7992 22.6268 17.2036 22.3421 17.333L16.8077 19.8487C16.5404 19.9702 16.3262 20.1844 16.2047 20.4516L13.689 25.9861C13.5596 26.2708 13.1552 26.2708 13.0258 25.9861L10.5101 20.4516C10.3886 20.1844 10.1744 19.9702 9.90716 19.8487L4.37272 17.333C4.088 17.2036 4.088 16.7992 4.37272 16.6698L9.90716 14.1541C10.1744 14.0326 10.3886 13.8184 10.5101 13.5511L13.0258 8.0167C13.1552 7.73197 13.5596 7.73197 13.689 8.0167Z",
			fill: "#E9F0FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.8297 10.4338L25.7214 12.8721C25.6351 13.062 25.3655 13.062 25.2792 12.8721L24.1708 10.4338C24.0494 10.1665 23.8351 9.95231 23.5679 9.83082L21.1295 8.72248C20.9397 8.6362 20.9397 8.36658 21.1295 8.2803L23.5679 7.17196C23.8351 7.05047 24.0494 6.83627 24.1708 6.56899L25.2792 4.13064C25.3655 3.94083 25.6351 3.94083 25.7214 4.13064L26.8297 6.56899C26.9512 6.83627 27.1654 7.05047 27.4327 7.17196L29.871 8.2803C30.0608 8.36658 30.0608 8.6362 29.871 8.72248L27.4327 9.83082C27.1654 9.95231 26.9512 10.1665 26.8297 10.4338Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.1708 23.569L25.2792 21.1306C25.3655 20.9408 25.6351 20.9408 25.7214 21.1306L26.8297 23.569C26.9512 23.8363 27.1654 24.0505 27.4327 24.172L29.871 25.2803C30.0608 25.3666 30.0608 25.6362 29.871 25.7225L27.4327 26.8308C27.1654 26.9523 26.9512 27.1665 26.8297 27.4338L25.7214 29.8721C25.6351 30.062 25.3655 30.062 25.2792 29.8721L24.1708 27.4338C24.0494 27.1665 23.8351 26.9523 23.5679 26.8308L21.1295 25.7225C20.9397 25.6362 20.9397 25.3666 21.1295 25.2803L23.5679 24.172C23.8351 24.0505 24.0494 23.8363 24.1708 23.569Z",
			fill: "#C4D7FD"
		})
	]
});
export default SvgIcStarsWhite;
